import React from "react";
import { useTranslation } from "react-i18next";
import { IconLiked, Iconlike } from "icons";
import { SleekToggle } from "components/Sleek/SleekToggle";

interface LikesFilterButtonProps {
  active: boolean;
  onClick: () => void;
}

// "Favorites" filter toggle, shared across every page toolbar, in the Trends pages' finish (2026-10-26: `SleekToggle`):
// outline heart when off, filled heart on ink when the liked-only filter is on.
const LikesFilterButton = ({ active, onClick }: LikesFilterButtonProps) => {
  const { t } = useTranslation();

  return (
    <SleekToggle
      active={active}
      onClick={onClick}
      icon={active ? <IconLiked style={{ width: 16, height: 16 }} className="flex-shrink-0" /> : <Iconlike style={{ width: 16, height: 16 }} className="flex-shrink-0" />}
      label={t("assets:_shared.buttons.favorites")}
    />
  );
};

export default LikesFilterButton;
